import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  const categoryImages = {
    "image-text": "https://readdy.ai/api/search-image?query=Collection%20of%20beautifully%20composed%20editorial%20photographs%20and%20illustrated%20magazine%20spreads%20arranged%20on%20a%20clean%20warm%20surface%2C%20soft%20natural%20light%2C%20cream%20and%20warm%20neutral%20palette%2C%20overhead%20flat%20lay%20photography&width=800&height=600&seq=cat-img-text&orientation=landscape",
    "video": "https://readdy.ai/api/search-image?query=Professional%20video%20production%20equipment%20with%20camera%20and%20lighting%20setup%20in%20a%20warm%20modern%20studio%2C%20cinematic%20film%20strips%20and%20video%20frames%20as%20decorative%20elements%2C%20warm%20amber%20lighting%2C%20creative%20atmosphere&width=800&height=600&seq=cat-video&orientation=landscape",
    "creative": "https://readdy.ai/api/search-image?query=Creative%20design%20tools%20scattered%20on%20wooden%20desk%20including%20color%20wheels%2C%20brushes%2C%20stylus%20pen%20and%20digital%20tablet%20with%20illustrations%20visible%2C%20warm%20natural%20light%2C%20artistic%20creative%20workspace%20atmosphere&width=800&height=600&seq=cat-creative&orientation=landscape",
    "template": "https://readdy.ai/api/search-image?query=Grid%20of%20elegant%20design%20templates%20and%20layouts%20displayed%20on%20screens%20and%20printed%20materials%2C%20minimal%20clean%20workspace%2C%20warm%20neutral%20tones%2C%20professional%20design%20portfolio%20presentation&width=800&height=600&seq=cat-template&orientation=landscape",
  };

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 text-primary-500 text-sm font-medium mb-3">
            <i className="ri-layout-grid-line"></i>
            <span>资源分类</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            海量原创资源，按需取用
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            涵盖图文、视频、创意素材、设计模板等多元类型，满足不同创作场景的资源需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-2xl bg-background-100 hover:shadow-md transition-all duration-300 cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              <div className="w-full h-48">
                <img
                  src={categoryImages[cat.slug as keyof typeof categoryImages]}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500/20 backdrop-blur-sm">
                    <i className={`${cat.icon} text-primary-300 text-sm`}></i>
                  </div>
                  <span className="font-heading font-semibold text-background-50 text-base">{cat.name}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-background-50/60 text-xs">{cat.count.toLocaleString()} 件资源</span>
                  <i className="ri-arrow-right-line text-background-50/60 group-hover:text-primary-300 group-hover:translate-x-1 transition-all duration-200 text-sm"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}